import { get } from 'svelte/store';
import WebsiteAPI from '../api/rest/directus-cms/app';
import DirectusCmsBannersApi from '../api/rest/directus-cms/banners';
import DirectusCmsOtherContactsApi from '../api/rest/directus-cms/menus';
import DirectusCmsPartnersApi from '../api/rest/directus-cms/partners';
import { Constants } from '../config/constants';
import { fallbackLocale } from '../services/i18n';
import { banners, commonWebsiteData, menus, menusTrans, partners, routes } from '../stores/stores';
const myRoutes = new Map();
export const resultSetMenusRoutes = async function setMenusRoutes() {
    const api = DirectusCmsOtherContactsApi.getInstance();
    await api
        .listAllMenus()
        .then(resp => {
        menus.set(resp.menu);
        get(menus).forEach(menu => {
            var _a;
            if (!menu.is_route)
                return;
            (_a = menu.translations) === null || _a === void 0 ? void 0 : _a.forEach(translation => {
                if (!translation.languages_id)
                    return;
                const langSlug = translation.languages_id.lang;
                const key = `${langSlug}${Constants.DOUBLE_BARS}${menu.slug}`;
                const link = translation.link;
                myRoutes.set(key, link);
                if (link.startsWith(`/${fallbackLocale}`)) {
                    const fallbackKey = `${Constants.FALLBACK_LANG}${Constants.DOUBLE_BARS}${menu.slug}`;
                    const fallbackLink = link.replace(new RegExp(`^/${fallbackLocale}`), '');
                    myRoutes.set(fallbackKey, fallbackLink);
                }
            });
        });
        routes.set(myRoutes);
    })
        .catch(error => {
        console.log('Error fetching menus', error);
    });
};
export async function listMenus(lang) {
    const api = DirectusCmsOtherContactsApi.getInstance();
    await api
        .listMenus(lang)
        .then(resp => {
        menusTrans.set(resp.menu);
    })
        .catch(error => {
        console.log('Error fetching menus list', error);
    });
}
export async function listBanners(lang, slug) {
    const api = DirectusCmsBannersApi.getInstance();
    await api
        .listBannersPage(lang, {
        filter: {
            page: {
                slug: { _eq: slug }
            }
        }
    })
        .then(resp => {
        banners.set(resp.banner);
    })
        .catch(error => {
        console.log('Error fetching banners of page', error);
    });
}
export async function listPartners(lang) {
    const api = DirectusCmsPartnersApi.getInstance();
    await api
        .listPartners(lang)
        .then(resp => {
        partners.set(resp.partners);
    })
        .catch(error => {
        console.log('Error fetching partners of page', error);
    });
}
export function retrieveCommonWebsiteData(lang) {
    WebsiteAPI.getInstance()
        .getWebsiteCollection(lang)
        .then(data => {
        commonWebsiteData.set(data);
    })
        .catch(error => console.log(error));
}
